module.exports = "https://cdn01.riselinkedu.com/assets/lottie/img_1.d55b8052.png";